import { render, staticRenderFns } from "./moreApprovalMenus.vue?vue&type=template&id=37bb0ac6&scoped=true&"
import script from "./moreApprovalMenus.vue?vue&type=script&lang=js&"
export * from "./moreApprovalMenus.vue?vue&type=script&lang=js&"
import style0 from "./moreApprovalMenus.vue?vue&type=style&index=0&id=37bb0ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bb0ac6",
  null
  
)

export default component.exports